import { NavigateFunction } from 'react-router-dom'

type TNavigationState =
    | {
          from?: string
      }
    | null
    | undefined

export const navigateBackOrFallback = (
    navigate: NavigateFunction,
    state?: TNavigationState,
    fallbackPath = '/services'
): void => {
    const previousRoute = state?.from
    if (previousRoute) {
        navigate(previousRoute)
        return
    }

    if (window.history.length > 1) {
        navigate(-1)
        return
    }

    navigate(fallbackPath)
}
